import { render } from "./IconCalendar.vue?vue&type=template&id=4790d8f1"
import script from "./IconCalendar.vue?vue&type=script&lang=js"
export * from "./IconCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__